import React from 'react';
import { useAppSelector } from '../../../store/hooks';

const RejectionBanner: React.FC = () => {
  const bookStatus = useAppSelector((state) => state.book.bookStatus);
  const reviewNotes = useAppSelector((state) => state.book.reviewNotes);

  if (bookStatus !== 'rejected' || !reviewNotes) {
    return null;
  }

  return (
    <div className="flex items-start gap-3 bg-red-50 border border-red-100 rounded-lg px-4 py-3 mb-4">
      <svg className="w-4 h-4 text-red-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-red-700 mb-0.5">Action required</p>
        <p className="text-xs text-red-600 leading-relaxed whitespace-pre-wrap">{reviewNotes}</p>
      </div>
    </div>
  );
};

export default RejectionBanner;
